var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20.5,
    r: 20,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_235_1724)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.7142 17.0748L29.1406 15.1762V12.0156C29.1406 11.6273 28.8258 11.3125 28.4375 11.3125H23.9844L20.4219 8.64062C20.1719 8.45312 19.8281 8.45312 19.5781 8.64062L16.0156 11.3125H11.5625C11.1742 11.3125 10.8594 11.6273 10.8594 12.0156V15.1762L8.2857 17.0748C8.10603 17.2074 8 17.4174 8 17.6406V31.7969C8 32.1852 8.31481 32.5 8.70312 32.5H31.2969C31.6852 32.5 32 32.1852 32 31.7969V17.6406C32 17.4174 31.894 17.2074 31.7142 17.0748ZM30.5938 17.9957V20.0177L29.1406 20.7413V16.9237L30.5938 17.9957ZM20 10.082L21.6406 11.3125H18.3594L20 10.082ZM27.7344 12.7188V21.4415L20 25.2927L12.2656 21.4415V12.7188H27.7344ZM10.8594 16.9237V20.7413L9.40625 20.0177V17.9957L10.8594 16.9237ZM9.40625 31.0938V21.5887L19.6866 26.7076C19.8839 26.8058 20.116 26.8059 20.3134 26.7076L30.5938 21.5887V31.0938H9.40625Z",
    fill: "#002D35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7812 16.9375H24.2188C24.6071 16.9375 24.9219 16.6227 24.9219 16.2344C24.9219 15.8461 24.6071 15.5312 24.2188 15.5312H15.7812C15.3929 15.5312 15.0781 15.8461 15.0781 16.2344C15.0781 16.6227 15.3929 16.9375 15.7812 16.9375Z",
    fill: "#002D35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7812 19.75H20C20.3883 19.75 20.7031 19.4352 20.7031 19.0469C20.7031 18.6586 20.3883 18.3438 20 18.3438H15.7812C15.3929 18.3438 15.0781 18.6586 15.0781 19.0469C15.0781 19.4352 15.3929 19.75 15.7812 19.75Z",
    fill: "#002D35"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_235_1724"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.e00a333e83267add018c0c5c22aecb9d.svg";
export { ForwardRef as ReactComponent };